var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: [_vm.wrapperClass, _vm.activeClass, _vm.errorClass] },
    [
      _vm.label ? _c("label", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "input-group-icon" }, [
        _vm.inputType === "checkbox"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password",
                },
              ],
              class: _vm.inputClass,
              attrs: {
                name: "password",
                disabled: _vm.disabled,
                placeholder: _vm.inputPlaceholder,
                tabindex: _vm.tabIndex,
                type: "checkbox",
              },
              domProps: {
                checked: Array.isArray(_vm.password)
                  ? _vm._i(_vm.password, null) > -1
                  : _vm.password,
              },
              on: {
                input: _vm.handleOnChangeInputPassword,
                blur: _vm.handleOnInputBlur,
                focus: _vm.handleOnInputFocus,
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.handleOnInputEnter.apply(null, arguments)
                },
                change: function ($event) {
                  var $$a = _vm.password,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.password = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.password = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.password = $$c
                  }
                },
              },
            })
          : _vm.inputType === "radio"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password",
                },
              ],
              class: _vm.inputClass,
              attrs: {
                name: "password",
                disabled: _vm.disabled,
                placeholder: _vm.inputPlaceholder,
                tabindex: _vm.tabIndex,
                type: "radio",
              },
              domProps: { checked: _vm._q(_vm.password, null) },
              on: {
                input: _vm.handleOnChangeInputPassword,
                blur: _vm.handleOnInputBlur,
                focus: _vm.handleOnInputFocus,
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.handleOnInputEnter.apply(null, arguments)
                },
                change: function ($event) {
                  _vm.password = null
                },
              },
            })
          : _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password",
                },
              ],
              class: _vm.inputClass,
              attrs: {
                name: "password",
                disabled: _vm.disabled,
                placeholder: _vm.inputPlaceholder,
                tabindex: _vm.tabIndex,
                type: _vm.inputType,
              },
              domProps: { value: _vm.password },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.password = $event.target.value
                  },
                  _vm.handleOnChangeInputPassword,
                ],
                blur: _vm.handleOnInputBlur,
                focus: _vm.handleOnInputFocus,
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.handleOnInputEnter.apply(null, arguments)
                },
              },
            }),
        _vm._v(" "),
        _c("i", {
          class: _vm.visibleIcon,
          on: { click: _vm.handleShowPassword },
        }),
      ]),
      _vm._v(" "),
      !_vm.replaceLabelWithError
        ? _c("p", { staticClass: "error-text" }, [
            _vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showPasswordSuggestion && !_vm.reseted && _vm.needPasswordSuggestion
        ? _c("div", [
            _c("div", { staticClass: "strength-bar" }, [
              _c(
                "div",
                { staticClass: "bar", class: _vm.barColor, style: _vm.barSize },
                [
                  _c("div", { staticClass: "bar-text" }, [
                    _vm._v(_vm._s(_vm.text[Math.max(0, _vm.score - 1)])),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.showFeedbackMessage
              ? _c("p", { staticClass: "feedback-warning" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.feedback.warning) +
                      "\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.showFeedbackMessage
              ? _c("div", { staticClass: "feedback-suggestion" }, [
                  _c(
                    "ul",
                    {
                      class: {
                        "double-columns": _vm.feedback.suggestions.length > 1,
                      },
                    },
                    _vm._l(_vm.feedback.suggestions, function (suggestion, i) {
                      return _c(
                        "li",
                        {
                          key: i,
                          class: { "is-fulfilled": suggestion.isFulfilled },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(suggestion.title) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }